import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import ReactSwipe from 'react-swipe'
import { connect } from 'react-redux'

import { getI18n } from 'client/i18n'
import styles from './empty_hub.less'

import PayPalPage from 'components/common/paypal_page'

import Separator from 'components/common/separator'
import FadeOutLink from 'components/common/fade_out_link'
import LearnMore from 'components/common/learn_more'

import Rocket from '!!babel-loader!react-svg-loader!images/rocket.svg' // eslint-disable-line import/no-unresolved
import People from '!!babel-loader!react-svg-loader!images/people.svg' // eslint-disable-line import/no-unresolved
import MoneyIn from '!!babel-loader!react-svg-loader!images/money_in.svg' // eslint-disable-line import/no-unresolved

const i18n = getI18n('components/pages/hub/empty_hub')

const EmptyHubTile = cssModules(({ title, text, iconElement }) => {
  // eslint-disable-line react/prop-types
  return (
    <div styleName="tile">
      <div styleName="tile-icon">{React.createElement(iconElement)}</div>
      <div styleName="tile-description">
        <div styleName="tile-description-contents">
          <div styleName="tile-title">{title}</div>
          <Separator type="dotted" />
          <div styleName="tile-text">{text}</div>
        </div>
      </div>
    </div>
  )
}, styles)

class EmptyHub extends React.Component {
  static propTypes = {
    campaigns: PropTypes.array,
    styles: PropTypes.object,
    dispatch: PropTypes.func,
    isMobile: PropTypes.bool,
  }

  state = { cardIndex: 0 }

  handleSwipeCallback = cardIndex => {
    this.setState({ cardIndex })
  }

  render() {
    const tileList = [
      <EmptyHubTile
        title={i18n('create')}
        text={i18n('create_text')}
        iconElement={Rocket}
        key="create"
      />,
      <EmptyHubTile
        title={i18n('share')}
        text={i18n('share_text')}
        iconElement={People}
        key="share"
      />,
      <EmptyHubTile
        title={i18n('collect')}
        text={i18n('collect_text')}
        iconElement={MoneyIn}
        key="collect"
      />,
    ]

    const steps = tileList.map((tile, index) => {
      let className = `${this.props.styles.bullet} ${
        index === this.state.cardIndex ? this.props.styles.current : ''
      }`
      return <div className={className} key={index} />
    })

    const swipeOptions = {
      callback: this.handleSwipeCallback,
      auto: this.props.isMobile ? undefined : 3000,
      speed: this.props.isMobile ? undefined : 500,
    }

    return (
      <PayPalPage>
        <div styleName="container">
          <svg width="0" height="0">
            <defs>
              <linearGradient
                x1="100%"
                y1="100%"
                x2="0%"
                y2="0%"
                id="cta_gradient"
              >
                <stop stopColor="#009CDE" offset="0%" />
                <stop stopColor="#00CF92" offset="100%" />
              </linearGradient>
            </defs>
          </svg>

          <div styleName="top-area">
            <div styleName="top-left-part">
              <div styleName="title">{i18n('title')}</div>
              <div styleName="subtitle">{i18n('subtitle')}</div>
              <div className="hidden-xs">
                <LearnMore showArrow={true} />
              </div>
            </div>
            <div styleName="top-right-part" className="hidden-xs">
              <FadeOutLink
                href={`${GLOBAL_CONSTS.REQUEST_URI}/c/create`}
                className="vx_btn vx_btn-medium"
                styleName="cta-button-top"
                data-pa-click="create"
                data-nemo="create-pool-button"
              >
                {i18n('cta_button')}
              </FadeOutLink>
            </div>
          </div>

          <div className="hidden-xs">
            <div style={{ clear: 'both' }} />
            <Separator type="dotted" />
          </div>

          <span className="visible-xs-block">
            <ReactSwipe
              swipeOptions={swipeOptions}
              styleName="hub-swipe-container"
            >
              {tileList.map((tile, i) => (
                <div styleName="mobile-tile-container" key={i}>
                  {tile}
                </div>
              ))}
            </ReactSwipe>

            <div styleName="steps">{steps}</div>
          </span>

          <span className="hidden-xs">
            <div styleName="tiles">
              {tileList}
              <span style={{ clear: 'both', display: 'block' }} />
            </div>
          </span>

          <div className="visible-xs-block">
            <FadeOutLink
              href={`${GLOBAL_CONSTS.REQUEST_URI}/c/create`}
              className="vx_btn vx_btn-large"
              styleName="cta-button"
              data-pa-click="create"
              data-nemo="mweb-create-pool-button"
            >
              {i18n('cta_button')}
            </FadeOutLink>

            <div styleName="learn-more-container">
              <LearnMore />
            </div>
          </div>
        </div>
      </PayPalPage>
    )
  }
}

export default connect(state => ({ isMobile: state.device_info.isMobile }))(
  cssModules(EmptyHub, styles, { allowMultiple: true })
)
